// for activation flow
export function getUserName() {
    let primaryUser: any = localStorage.getItem('customerDetail');
    primaryUser = JSON.parse(primaryUser);
    let secondaryUser: any = localStorage.getItem('secondaryCustomerDetail');
    secondaryUser = JSON.parse(secondaryUser);
    const user: any = secondaryUser || primaryUser;
    return (user?.firstName || user?.lastName)?.toUpperCase() || '';
}

// for homepage/account and services pages
export function returnName(el: any, name: any) {
    return name === 'firstName'
        ? el?.firstName?.toUpperCase() || ''
        : el?.lastName?.toUpperCase() || '';
}
